import { Action, OperationType } from '../../../dispatcher/Types';

export const TabPanelForm: Action = [{
  mappingName: 'allTabsData',
  moduleName: 'TabPanelForm',
  name: 'getAllData',
  type: OperationType.addOperationData
}];

export const addTab: Action = [{
  evaluate: true,
  moduleName: 'TabPanelForm',
  name: 'addTab',
  args: ['{{renderComponent}}', 'isFocused', 'title', 'placeItem', 'isDisabled', 'moduleId']
}];

export const addMultipleTabs: Action = [{
  evaluate: true,
  moduleName: 'TabPanelForm',
  name: 'addMultipleTabs',
  args: ['{{renderComponents}}', 'focusedItem']
}];

export const deleteTab: Action = [{
  moduleName: 'TabPanelForm',
  name: 'deleteTab',
  args: ['placeIndex']
}];

export const getTotalTabCount: Action = [{
  mappingName: 'totalTabCount',
  moduleName: 'TabPanelForm',
  name: 'getTabCount',
  type: OperationType.addOperationData
}];

export const getSelectedTab: Action = [{
  mappingName: 'currTabNum',
  moduleName: 'TabPanelForm',
  name: 'getSelectedTab',
  type: OperationType.addOperationData
}];

export const switchTab: Action = [{
  name: 'getSelectedTab',
  type: OperationType.action
}, {
  moduleName: 'TabPanelForm',
  name: 'setSelectedTab',
  args: ['currTabNum', 'num', 'isIncrement']
}];

export const setDisabledTab: Action = [{
  evaluate: true,
  moduleId: '{moduleId}',
  moduleName: 'TabPanelForm',
  name: 'setDisabledTab',
  args: ['placeIndex', 'disabled']
}];
